import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../style/login.css";
import { FaGoogle, FaApple, FaFacebook, FaEye, FaEyeSlash, FaDownload } from "react-icons/fa";
import BackgroundImage from "../assets/waterbg.jpg";

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = () => {
    // Hardcoded credentials for role-based redirection
    const adminCredentials = { username: "admin@gmail.com", password: "admin123" };
    const executiveCredentials = { username: "executive@gmail.com", password: "exec123" };
    const userCredentials = { username: "sparsh", password: "sparsh123" };

    if (username === adminCredentials.username && password === adminCredentials.password) {
      navigate("/admin", { state: { username } });
    } 
    // else if (username === executiveCredentials.username && password === executiveCredentials.password) {
    //   navigate("/executive", { state: { username } });
    // } else if (username === userCredentials.username && password === userCredentials.password) {
    //   navigate("/home", { state: { username } });
    // } 
    else {
      alert("Invalid credentials. Please try again.");
    }
  };

  // PWA Install
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstall = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the PWA install prompt');
        } else {
          console.log('User dismissed the PWA install prompt');
        }
        // Clear the deferredPrompt after installation
        setDeferredPrompt(null);
        setIsInstallable(false);
      });
    }
  };

  return (
    <div className="container" style={{ backgroundImage: `url(${BackgroundImage})` }}>
      <div className="sidebar"></div>
      <div className="login-box">
        {isInstallable && (
          <button
            id="install-button"
            onClick={handleInstall}
            className="login-btn"
            style={{ padding: "12px 5px", width: "150px", background: "green" }}
          >
            <FaDownload /> Install PWA
          </button>
        )}
        <h2>Water Meter Login</h2>
        <input
          type="text"
          placeholder="Enter Username"
          className="inputs-box"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <div className="password-container">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            className="inputs-box"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button className="icon-btn" onClick={togglePassword}>
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>

        {/* <p className="help-text">Having trouble signing in?</p> */}
        <button className="login-btn" onClick={handleLogin}>Sign in</button>
        
        {/* <p className="or-text">— Or Sign in with —</p> */}
        {/* <div className="social-icons">
          <button className="social-btn"><FaGoogle /> Google</button>
          <button className="social-btn"><FaApple /> Apple ID</button>
          <button className="social-btn"><FaFacebook /> Fb</button>
        </div> */}
        {/* <p>powered by @Dexpert Systems</p> */}
        <p className="footer-text">
        powered by @Dexpert Systems
        </p>
      </div>

      {/* <div className="footer">
        <p>powered by @Dexpert Systems</p>
      </div> */}
    </div>
  );
}

export default Login;
